import $ from 'jquery'
import CONSTS from '../constants'
import Component from './component'

export class TopNavigationSidebar extends Component {
  constructor(ctx, ev) {
    super(ctx, ev)

    // classes extensions
    Object.assign(this.classes, {
      showFormLink: '.js-top-navigation-show-form-link',
      rightItem: '.js-top-navigation-menu2-item-right',
      rightDefaultItem: '.js-top-navigation-menu2-item-right.h-default',
      notification: '.js-top-navigation-notification',
      form: 'form',
      input: 'input',
      inputSubmit: '.h-btn-submit',
      textarea: 'textarea',
      errorText: '.h-error-text',
      loginForm: '.js-top-navigation-login-form',
      closeRightBtn: '.js-top-navigation-close-menu2-item-right',
    })

    // classStates extensions
    Object.assign(this.classStates, {
      hasSubMenu: 'h-has-submenu',
      error: 'h-has-error',
      isSearchForm: 'a-search__form',
    })

    this.$closeRightBtn = this.$ctx.find(this.classes.closeRightBtn)
    this.$showFormLinks = this.$ctx.find(this.classes.showFormLink)
    this.$forms = this.$ctx.find(this.classes.form)
    this.$inputs = this.$ctx.find(this.classes.input)
    this.$loginForm = this.$ctx.find(this.classes.loginForm)

    this.bindCloseRightBtn()
    this.bindEsc()
    this.bindShowFormLinks()
    this.bindFormSubmits()

    this.listenToEvents()
  }

  bindCloseRightBtn() {
    this.$closeRightBtn.on('click', (event) => {
      event.preventDefault()

      this.$ctx
        .find(this.classes.rightItem)
        .removeClass(this.classStates.active)
    })
  }

  bindEsc() {
    $(document).on(`keydown.${this.constructor.name}`, (event) => {
      const RADIX = 10
      const KEY_ESCAPE = 27

      if (window.parseInt(event.which, RADIX) === KEY_ESCAPE && this.active) {
        const $rightItemActive = this.$ctx.find(
          `${this.classes.rightItem}.${this.classStates.active}`
        )

        if ($rightItemActive.length > 0) {
          $rightItemActive.removeClass(this.classStates.active)
        }
      }
    })
  }

  bindShowFormLinks() {
    this.$showFormLinks.on('click', (event) => {
      event.preventDefault()

      const $me = $(event.currentTarget)
      const form = $me.data('form')
      const $menuLevel2 = $me.parents(this.classes.menuLevel2)
      const $rightItems = $menuLevel2.find(this.classes.rightItem)
      const $formContainer = $menuLevel2.find(`.${form}`)

      if ($formContainer.length > 0) {
        $rightItems.removeClass(this.classStates.active)

        // make active and focus first input field
        $formContainer
          .addClass(this.classStates.active)
          .find('input:visible:first')
          .focus()
      }
    })
  }

  bindFormSubmits() {
    this.$forms.on('submit', (event) => {
      const $form = $(event.currentTarget)

      if ($form.hasClass(this.classStates.isSearchForm)) {
        return
      }

      event.preventDefault()

      const $inputs = $form
        .find(this.classes.input)
        .not(this.classes.inputSubmit)
      const $textarea = $form.find(this.classes.textarea)
      const $errorTexts = $form.find(this.classes.errorText)
      const $notification = $form
        .closest(this.classes.menuLevel2)
        .find(this.classes.notification)

      $.ajax({
        type: 'POST',
        data: $form.serialize(),
        dataType: 'json',
        url: $form.attr('action'),
        success: (data) => {
          if (data.status === 'error') {
            $inputs.removeClass(this.classStates.error)
            $textarea.removeClass(this.classStates.error)

            $errorTexts.empty().addClass(this.classStates.hidden)

            if (data.msg !== null && typeof data.msg === 'object') {
              for (const key in data.msg) {
                // eslint-disable-next-line no-prototype-builtins
                if (data.msg.hasOwnProperty(key)) {
                  const $input = $(`#${key}`, $form)
                  const $error = $(`#${key}_error`, $form)
                  const errorMsg = data.msg[key]

                  $input.addClass(this.classStates.error)

                  $error.html(errorMsg).removeClass(this.classStates.hidden)
                }
              }
            } else {
              // add to last input field
              $inputs.last().addClass(this.classStates.error)

              $errorTexts
                .last()
                .removeClass(this.classStates.hidden)
                .html(data.msg)
            }
            // works, form is sent
          } else if (data.status === 'success') {
            this.showNotification($notification, data.msg)

            // clean up form
            $inputs.removeClass(this.classStates.error).val('')

            $textarea.removeClass(this.classStates.error).val('')

            $errorTexts.empty().addClass(this.classStates.hidden)
            // works, we need to redirect
          } else if (data.status === 'success_redirect') {
            if (data.redirect.length > 0) {
              location.href = data.redirect
            }
          }
        },
        error: () => false,
      })
    })

    // enter current form on keypress enter
    this.$inputs.on('keypress', (event) => {
      const ENTER_KEY = 13
      const RADIX = 10

      if (window.parseInt(event.which, RADIX) === ENTER_KEY) {
        event.preventDefault()

        const $target = $(event.currentTarget)
        const $form = $target.closest(this.classes.form)

        $form.submit()
      }
    })
  }

  showNotification($notification, msg) {
    const DELAY = 2000

    $notification.find('p').html(msg)
    $notification.show()

    window.setTimeout(() => {
      $notification.hide()
      this.makeDefaultRightVisibleAgain()
    }, DELAY)
  }

  makeDefaultRightVisibleAgain() {
    this.$ctx.find(this.classes.rightItem).removeClass(this.classStates.active)

    this.$ctx
      .find(this.classes.rightDefaultItem)
      .addClass(this.classStates.active)
  }

  listenToEvents() {
    this.ev.on(CONSTS.EVENTS.SHOW_LOGIN, () => {
      if (this.active && this.$loginForm.length > 0) {
        const DELAY = 50

        this.ev.emit(CONSTS.EVENTS.OPEN_SIDE_NAVI)

        window.setTimeout(() => {
          this.$ctx
            .find(this.classes.rightItem)
            .removeClass(this.classStates.active)

          // make active and focus first input field
          this.$loginForm
            .addClass(this.classStates.active)
            .find('input:visible:first')
            .trigger('focus')
        }, this.durations.animationInSideNavi + DELAY)
      }
    })
  }

  onResize(winWidth) {
    if (winWidth > CONSTS.MOBILE_WIDTH) {
      this.active = false

      this.$ctx
        .find(this.classes.rightItem)
        .removeClass(this.classStates.active)
    } else {
      this.active = true
    }
  }
}
